import styled, { css } from 'styled-components'
import { AdditionalEmployeesProps, ProfileImageProps } from './types'

export const ProfileImage = styled.img<ProfileImageProps>`
  ${({ noMargin, small }) => css`
    width: ${small ? '25px' : '35px'};
    height: ${small ? '25px' : '35px'};
    border-radius: 100%;
    margin-right: ${noMargin ? 0 : small ? '-10px' : '-15px'};
    border: 2px solid #fff;
    background-color: #fff;
  `}
`

export const AdditionalEmployees = styled.div<AdditionalEmployeesProps>`
  ${({ small }) => css`
    user-select: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: ${small ? '25px' : '35px'};
    height: ${small ? '25px' : '35px'};
    margin-left: ${small ? '-5px' : '-5px'};
    line-height: 1;
    font-size: ${small ? '10px' : 'inherit'};
    font-weight: 500;
    background: linear-gradient(
        0deg,
        rgba(42, 94, 246, 0.05),
        rgba(42, 94, 246, 0.05)
      ),
      #ffffff;
    border-radius: 50%;
    border: 1px solid #2a5ef61a;
  `}
`
